import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h4 className="text-lg font-bold font-heading text-background-50 mb-4">
              <Link to="/" className="hover:text-primary-400 transition-colors cursor-pointer">免费韩漫大全</Link>
            </h4>
            <p className="text-sm text-secondary-300 leading-relaxed">
              韩国漫画在线阅读平台，涵盖热血、恋爱、奇幻等全品类韩漫。无需注册，免费阅读，每日更新最新章节。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">分类浏览</h4>
            <ul className="space-y-2.5">
              {categories.filter(c => c.slug !== 'all').map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-secondary-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">快速链接</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link></li>
              <li><Link to="/category/action" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors cursor-pointer">热门推荐</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="text-sm text-secondary-300">
                <i className="ri-mail-line mr-2"></i>
                contact@freekcomic.com
              </li>
              <li className="text-sm text-secondary-300">
                <i className="ri-map-pin-line mr-2"></i>
                韩国首尔特别市江南区
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-secondary-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-400">
            &copy; {currentYear} 免费韩漫大全 - 韩国漫画在线阅读平台. All Rights Reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-secondary-400 hover:text-primary-400 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-secondary-400 hover:text-primary-400 transition-colors" rel="nofollow">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}